/* TNS v4 minimal script — scroll reveal + count-up + cart bubble */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Scroll reveal
  if ('IntersectionObserver' in window && !prefersReducedMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.tn-reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.tn-reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  // Count-up numbers strip
  function formatVal(target, raw) {
    var suffix = target.dataset.suffix || '';
    var prefix = target.dataset.prefix || '';
    var decimals = parseInt(target.dataset.decimals || '0', 10);
    return prefix + raw.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + suffix;
  }
  function animateCount(el) {
    var end = parseFloat(el.dataset.value);
    if (isNaN(end)) return;
    if (prefersReducedMotion) { el.textContent = formatVal(el, end); return; }
    var dur = 1200, start = performance.now();
    function step(now) {
      var t = Math.min(1, (now - start) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = formatVal(el, end * eased);
      if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  if ('IntersectionObserver' in window) {
    var co = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCount(entry.target);
          co.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('[data-count-up]').forEach(function (el) { co.observe(el); });
  } else {
    document.querySelectorAll('[data-count-up]').forEach(animateCount);
  }

  // Cart bubble refresh
  function refreshCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.tn-cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      })
      .catch(function () {});
  }
  refreshCart();
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[action*="/cart/add"]');
    if (!f) return;
    setTimeout(refreshCart, 800);
  });
})();
